import React, { useEffect, useState, useCallback } from 'react';
import classNames from 'classnames';

import Panel from './index';

import './styles.css';

export default function Modal({ className, children, onClose, style }) {
  const [visible, setVisible] = useState(false);
  const onCloseClick = useCallback((event) => {
    setVisible(false);
    setTimeout(() => onClose(), 500);
  });
  useEffect(() => {
    setVisible(true);
  }, []);

  const css = classNames('Components_modal mx-4 shadow', className, {
    'show': visible,
    'hide': !visible,
  });

  return (
    <div
      role="button"
      className="Components_modal_blocker fixed flex justify-center items-center inset-0 z-50 cursor-auto"
    >
      <Panel className={css} style={style}>
        {
          React.Children.map(children, child => {
            if (child) {
              return React.cloneElement(child, {
                onClose: onCloseClick,
              });
            } else {
              return child;
            }
          })
        }
      </Panel>
    </div>
  );
}
